export const GET_LOCATION_SUGGESTIONS = 'GET_LOCATION_SUGGESTIONS'
export const GET_LOCATION_SUGGESTIONS_LOADING = 'GET_LOCATION_SUGGESTIONS_LOADING'
export const GET_LOCATION_SUGGESTIONS_SUCCESS = 'GET_LOCATION_SUGGESTIONS_SUCCESS'
export const GET_LOCATION_SUGGESTIONS_ERROR = 'GET_LOCATION_SUGGESTIONS_ERROR'
export const SEARCH_FOR_CITY = 'SEARCH_FOR_CITY'
export const SEARCH_FOR_CITY_LOADING = 'SEARCH_FOR_CITY_LOADING'
export const SEARCH_FOR_CITY_SUCCESS = 'SEARCH_FOR_CITY_SUCCESS'
export const SEARCH_FOR_CITY_ERROR = 'SEARCH_FOR_CITY_ERROR'
